import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import config from '../config';

function Navigation() {
  const [activeSection, setActiveSection] = useState('');
  const { resumeLink } = config;

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['about', 'experience', 'projects'];
      const scrollPosition = window.scrollY + 100;

      const currentSection = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const topOffset = rect.top + window.scrollY;
          const bottomOffset = rect.bottom + window.scrollY;
          
          return scrollPosition >= topOffset && scrollPosition < bottomOffset;
        }
        return false;
      });
      
      setActiveSection(currentSection || '');
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (sectionId) => {
    const element = document.getElementById(sectionId);
    const headerHeight = 90;
    
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  return (
    <nav className="section-nav">
      <ul>
        <li>
          <button 
            className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
            onClick={() => handleClick('about')}
          >
            ABOUT
          </button>
        </li>
        <li>
          <button 
            className={`nav-link ${activeSection === 'experience' ? 'active' : ''}`}
            onClick={() => handleClick('experience')}
          >
            EXPERIENCE
          </button>
        </li>
        <li>
          <button 
            className={`nav-link ${activeSection === 'projects' ? 'active' : ''}`}
            onClick={() => handleClick('projects')}
          >
            PROJECTS
          </button>
        </li>
        <li>
          <Link to="/cv" className="nav-link">
            CV
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation; 